module.exports = __webpack_public_path__ + "static/img/ban-7.26828b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ban-7.png
// module id = 6StP
// module chunks = 0